/**
 * Centralized utility to resolve and prepend the app's base path prefix to local static assets.
 */
export const BASE_PATH = "";

export const getAssetPath = <T extends string | object | null | undefined>(path: T): T => {
  if (!path) return path;

  // Next.js static imports yield objects (StaticImageData) - don't modify them
  if (typeof path === "object" && path !== null) {
    return path;
  }

  const pathStr = String(path);

  // If the path is already prefixed, is external, or is a base64 data URL, return it as is
  if (
    pathStr.startsWith("http://") ||
    pathStr.startsWith("https://") ||
    pathStr.startsWith("data:") ||
    pathStr.startsWith(`${BASE_PATH}/`) ||
    pathStr === BASE_PATH
  ) {
    return path;
  }

  // Ensure leading slash
  const cleanPath = pathStr.startsWith("/") ? pathStr : `/${pathStr}`;

  return `${BASE_PATH}${cleanPath}` as unknown as T;
};
